<template>
  <el-container>
    <el-aside width="208">
      <div class="logo">
        <img :src="logo">
      </div>
      <el-menu width="208" :router="true" :default-active="handlerDetail($route.path)">
        <el-menu-item index="/Home/Default">
          <template slot="title">
            <svg-icon icon-class="AgencyHome" />{{ $t('comm.default') }}
          </template>
        </el-menu-item>
         <el-menu-item index="/Home/ProductPicture">
          <template slot="title">
            <svg-icon icon-class="productPicture" />{{ $t('comm.productPicture') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/ItemCodeQuery">
          <template slot="title">
            <svg-icon icon-class="itemCodeQuery" />{{ $t('comm.itemCodeQuery') }}
          </template>
        </el-menu-item>
         <!-- <el-menu-item index="/Home/PubPriceQuery">
          <template slot="title">
            <svg-icon icon-class="PubPriceQuery" />{{ $t('comm.pubPriceQuery') }}
          </template>
        </el-menu-item> -->
        <el-menu-item index="/Home/StockRemainQuery">
          <template slot="title">
            <svg-icon icon-class="UrgentQuery" />{{ $t('comm.stockRemainQuery') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/OrderImport">
          <template slot="title">
            <svg-icon icon-class="OrderImport" />{{ $t('comm.orderImport') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/OrderImportSer">
          <template slot="title">
            <svg-icon icon-class="OrderImportSer" />{{ $t('comm.orderImportSer') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/SalSalesOrder">
          <template slot="title">
            <svg-icon icon-class="salSalesOrder" />{{ $t('comm.salSalesOrder') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/UrgentQuery">
          <template slot="title">
            <svg-icon icon-class="UrgentQuery" />{{ $t('UrgentQuery.title') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/ShipmentQuery">
          <template slot="title">
            <svg-icon icon-class="ShipmentQuery" />{{ $t('ShipmentQuery.title') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/OrderArrival">
          <template slot="title">
            <svg-icon icon-class="OrderArrival" />{{ $t('comm.orderArrival') }}
          </template>
        </el-menu-item>
        <el-menu-item index="/Home/SalDispatchList">
          <template slot="title">
            <svg-icon icon-class="SalDispatchList" />{{ $t('comm.salDispatchList') }}
          </template>
        </el-menu-item>
        <el-menu-item v-for="page in operationMenu" :index="'/Home/OperationMenu-'+page.UId">
          <template slot="title">
            <svg-icon icon-class="salSalesOrder" />{{ page.DisplayName }}
          </template>
        </el-menu-item>
        <!-- <el-submenu index="/Home/OperationMenu" v-if="operationMenu.length!=0">
          <template slot="title">
            <svg-icon icon-class="AgencyOptMenu" />{{ $t('comm.operationmenu') }}
          </template>
          <el-menu-item v-for="page in operationMenu" :index="'/Home/OperationMenu-'+page.UId">{{ page.DisplayName }}</el-menu-item>
        </el-submenu> -->
        <!-- <el-menu-item index="/Home/APSearch">
          <template slot="title">
            <svg-icon icon-class="AgencyTransaction" />{{ $t('comm.APSearch') }}
          </template>
        </el-menu-item> -->
        <!-- <el-submenu index="/Home/DownLoad">
          <template slot="title">
            <svg-icon icon-class="AgencyDownload" />{{ $t('comm.download') }}
          </template>
          <el-menu-item index="/Home/SortFile">{{ $t('comm.sortfile') }}</el-menu-item>
          <el-menu-item v-show="SCM78" index="/Home/DownloadPrint">{{ $t('comm.downloadprint') }}</el-menu-item>
        </el-submenu> 
        <el-menu-item index="/Home/HelpCenter">
          <template slot="title">
            <svg-icon icon-class="AgencyHelpCenter" />{{ $t('comm.help') }}
          </template>
        </el-menu-item> 
        <el-submenu index="/Home/InformCenter">
          <template slot="title">
            <svg-icon icon-class="AgencyInformCenter" />{{ $t('comm.inform') }}
          </template>
          <el-menu-item index="/Home/BulletinCenter">{{ $t('comm.bulletin') }}</el-menu-item>
        </el-submenu> -->
      </el-menu>
    </el-aside>

    <el-container style="background-color:#859faf17">
      <el-header>
        <div class="headAdInfo">
          <span :title="AdMessage" class="AdMessage">{{ AdMessage }}</span>
          <span>{{ $t('Home.PhoneNumber')+"："+PersonName+" - "+TelNo }}</span>
        </div>
        <div class="headinfo">
          <div class="user">
            <svg-icon style="transform:scale(0.65);margin: auto 0;" icon-class="Profile" />
            <XElTooltip :overflow="true" :content="username" placement="bottom">
              <span style="margin: auto 0;" >{{ username }}</span>
            </XElTooltip>
            <el-dropdown @command="handleCommand" trigger="click">
              <i class="el-icon-arrow-down"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="userInfo">{{ $t('Home.userInfo') }}</el-dropdown-item>
                <el-dropdown-item command="changePwd">{{ $t('Home.changepassword') }}</el-dropdown-item>
                <el-dropdown-item command="billSetting">{{ $t('Home.billsetting') }}</el-dropdown-item>
                <el-dropdown-item command="loginInfo">{{ $t('Home.register') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="button exit" @click="doLoginout">
            <svg-icon style="transform:scale(0.65);margin: auto 0;" icon-class="Exit" />{{ $t('Home.back') }}
            <!-- <el-button class="button" type="text">{{ $t('Home.back') }}</el-button> -->
          </div>
        </div>
      </el-header>
      <Keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </Keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <DialogChangePwd ref="dialog"></DialogChangePwd>
      <el-dialog :title=" $t('Home.logininfo')" :visible="userinfodialog" width="30%" :before-close="handleClose">
        <div style="padding-left:5%" v-loading="dialoading">
          <div class="logininfo-row"><div class="row-dot"></div><span>{{ $t('Home.createtime') }}:</span><span class="row-detail">{{userinfo.CreateTime}}</span></div>
          <div class="logininfo-row"><div class="row-dot"></div><span>{{ $t('Home.lastlogindate') }}:</span><span class="row-detail">{{userinfo.LastLoginDate}}</span></div>
          <div class="logininfo-row"><div class="row-dot"></div><span>{{ $t('Home.membertype') }}:</span><span class="row-detail">{{userinfo.MemberType}}</span></div>
          <div class="logininfo-row"><div class="row-dot"></div><span>{{ $t('Home.ipaddress') }}:</span><span class="row-detail">{{userinfo.IP}}</span></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="userinfodialog =false">{{ $t('comm.confirm') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="$t('Home.billsetting')" :visible="billSettingdialog" width="500px" :before-close="BillhandleClose">
        <div style="padding-left:5%" v-loading="dialoading">
          <div class="billsetting-row">
            <div class="billsetting-title">
              {{ $t('Home.toolbarShowStyle') }}:
            </div>
            <div class="billsetting-options">
              <el-radio v-model = "toolbarShowStyle" label="showIconAndText">  {{ $t('Home.showIconAndText') }}</el-radio>
              <el-radio v-model = "toolbarShowStyle" label="showIcon">  {{ $t('Home.showIcon') }}</el-radio>
              <el-radio v-model = "toolbarShowStyle" label="showText">  {{ $t('Home.showText') }}</el-radio>
            </div>
          </div>
          <div class="billsetting-row">
            <div class="billsetting-title">{{ $t('Home.fieldRawTextType') }}:</div>
            <div class="billsetting-options">
              <el-radio v-model = "fieldRawTextType" label="0">{{ $t('Home.showcodeandname') }}</el-radio>
              <el-radio v-model = "fieldRawTextType" label="1">{{ $t('Home.showname') }}</el-radio>
              <el-radio v-model = "fieldRawTextType" label="2">{{ $t('Home.showcode') }}</el-radio>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button  @click="billSettingdialog =false">{{ $t('button.Cancel')}}</el-button>
          <el-button type="primary" @click="confirmBillSetting">{{ $t('comm.confirm') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="$t('Home.userInfo')" :center="true" :visible.sync="userInfoDialog" width="800px" v-loading="userInfoLoading" :before-close="userInfoClose">
        <div class="useinfo-contain">
          <div>
            <span  class="userinfo-label">{{$t('Home.customer')}}:</span>
            <span style="margin: auto 0;">{{ BizPartnerName }}</span>
          </div>
          <div>
            <div class="userinfo-label">{{$t('Home.email')}}:</div>
            <div class="userinfo-info" v-if="!emailEdit" @click="emailEdit = true">
              <svg-icon class="changeIcon" icon-class="changeaddress-blue" style="width: 13px;height: 13px;" />
              <div class="userinfo-content">{{ email }}</div>
            </div>
            <div class="userinfo-info" v-if="emailEdit" >
              <el-input style="width:100%" v-model="email" maxlength="100"></el-input>
              <div class="userinfo-btns">
                <el-button type="primary" @click="SubmitUserInfo">{{ $t("button.determine") }}</el-button>
                <el-button @click="emailEdit = false">{{ $t("button.cancel") }}</el-button>
              </div>
            </div>
          </div>  
          <div>
            <span  class="userinfo-label">{{$t('Home.Address')}}:</span>
            <div class="userinfo-info" v-if="!AddressEdit" @click="AddressEdit = true">
              <svg-icon class="changeIcon" icon-class="changeaddress-blue" style="width: 13px;height: 13px;" />
              <span class="userinfo-content">{{ address }}</span>
            </div>
            <div class="userinfo-info"  v-if="AddressEdit && language!='en'" >
              <div class="addr-label">{{ $t('Home.Country') }}:</div>
              <el-select v-model="CountryId" @change = "ProvinceId = '';CityId = ''">
                <el-option
                  v-for="item in CountryDataTable"
                  :key="item.CountryId"
                  :label="item.CountryName"
                  :value="item.CountryId">
                </el-option>
              </el-select>
              <div class="addr-label">{{ $t('Home.Province') }}:</div>
              <el-select v-model="ProvinceId" @change = "CityId = ''">
                <el-option
                  v-for="item in filProvDt"
                  :key="item.ProvinceId"
                  :label="item.ProvinceName"
                  :value="item.ProvinceId">
                </el-option>
              </el-select>
              <div class="addr-label">{{ $t('Home.City') }}:</div>
              <el-select v-model="CityId">
                <el-option
                  v-for="item in filCityDt"
                  :key="item.CityId"
                  :label="item.CityName"
                  :value="item.CityId">
                </el-option>
              </el-select>
              <div class="addr-label">{{ $t('Home.ContactAddress') }}:</div>
              <el-input v-model="ContactAddress" maxlength="255"></el-input>
              <div class="userinfo-btns">
                <el-button type="primary" @click="SubmitUserInfo">{{ $t("button.determine") }}</el-button>
                <el-button @click="AddressEdit = false">{{ $t("button.cancel") }}</el-button>
              </div>
            
            </div>
            <div class="userinfo-info"  v-if="AddressEdit && language=='en'" >
              <div class="addr-label">{{ $t('Home.ContactAddress') }}:</div>
              <el-input v-model="ContactAddress" maxlength="255"></el-input>
              <div class="addr-label">{{ $t('Home.City') }}:</div>
              <el-select v-model="CityId">
                <el-option
                  v-for="item in filCityDt"
                  :key="item.CityId"
                  :label="item.CityName"
                  :value="item.CityId">
                </el-option>
              </el-select>
              <div class="addr-label">{{ $t('Home.Province') }}:</div>
              <el-select v-model="ProvinceId" @change = "CityId = ''">
                <el-option
                  v-for="item in filProvDt"
                  :key="item.ProvinceId"
                  :label="item.ProvinceName"
                  :value="item.ProvinceId">
                </el-option>
              </el-select>
              <div class="addr-label">{{ $t('Home.Postalcode') }}:</div>
              <el-input v-model="Postalcode" maxlength="255"></el-input>
              <div class="addr-label">{{ $t('Home.Country') }}:</div>
              <el-select v-model="CountryId" @change = "ProvinceId = '';CityId = ''">
                <el-option
                  v-for="item in CountryDataTable"
                  :key="item.CountryId"
                  :label="item.CountryName"
                  :value="item.CountryId">
                </el-option>
              </el-select>
              
              <div class="userinfo-btns">
                <el-button type="primary" @click="SubmitUserInfo">{{ $t("button.determine") }}</el-button>
                <el-button @click="AddressEdit = false">{{ $t("button.cancel") }}</el-button>
              </div>
            
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- <div class="footer">{{ webSupCopyRight }} &nbsp;&nbsp;<span class="linkHref" @click="linkHref();">{{ internetContentProvider }}</span></div> -->
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import DialogChangePwd from '@/components/DialogChangePwd';
import XElTooltip from "@/components/X-el-tooltip.vue";
import {loadAndUpdateVersion} from "@/utils/utils"
import {getAgencyConfig} from '../utils/utils'
export default {
  components: {
    DialogChangePwd,XElTooltip
  },
  data() {
    return {
      loginDate:'',
      username: "",
      userId:"",
      timer: '',
      SCM78:false,
      QM01:false,
      dialogFormVisible: false,
      labelPosition: "right",
      logo: '',
      userinfodialog:false,
      billSettingdialog:false,
      dialoading:false,
      toolbarShowStyle:'showIconAndText',
      fieldRawTextType:'0',
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: ""
      },
      userinfo:{},
      operationMenu: [],
      webSupCopyRight:'',
      internetContentProvider:'',
      internetContentProviderHref:'',
      IsA10:sessionStorage.getItem("VersionType","A10"),
      AdMessage:'',
      TelNo:'',
      PersonName:'',
      userInfoDialog:false,
      email:'',
      AddressEdit:false,
      emailEdit:false,
      userInfoLoading:false,
      BizPartnerName:'',
      ContactAddress:'',
      CountryDataTable:[],
      ProvinceDataTable:[],
      CityDataTable:[],
      CountryId:'',
      ProvinceId:'',
      CityId:'',
      ContactAddress:'',
      OriginUserInfo:null,
      Postalcode:'',
      language:"zh-CHS",
    };
  },
  async created() {
    this.getOperationMenu();
    this.getUserConfig();
    this.invokeKeepAlive();
    this.axiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx?",
      { action: 'getuserinfo' },
      (res) => {
        var userinfo = eval(res.data);
        this.username = userinfo[0].username;
        this.userId = userinfo[0].userId;
        this.logo = userinfo[0].logo;
      })
    this.$store.commit("GETPAGESIZE",localStorage.getItem("pagesize")?Number(localStorage.getItem("pagesize")):10);
    let headinfo = await getAgencyConfig(this);
    if(headinfo.TelNo) this.TelNo = headinfo.TelNo;
    if(headinfo.PersonName) this.PersonName=headinfo.PersonName;
    this.AdMessage = headinfo.AdMessage;
    this.CheckDeployPackage();
  },
  methods: {
    //保持连线
    invokeKeepAlive() {
      if (sessionStorage.getItem("KeepAlive") && sessionStorage.getItem("KeepAlive") == "KeepAlive") {
        this.timer = setInterval(this.keepAlive, 30000);
      }
    },

    //连线请求
    keepAlive() {
      this.axiosInvoke("/Functions/Sys.ashx", { action: 'keepalive' });
    },

    //登出操作
    doLoginout() {
      this.axiosInvoke("/AgencyComm/handler/SysHandler.ashx?",
        { action: 'logout' },
        (res) => {
          var resData = res.data;
          if (this.timer) {
            clearInterval(this.timer);
          }
          console.log(resData);
        })
      this.$router.replace("/");
    },
    getUserConfig() {
      this.axiosInvoke("/AgencyComm/Handler/LoginHandler.ashx", {
        action: "getuserconfig",
      },
        res => {
          let data = eval(res.data);
          this.loginDate = decodeURIComponent(data[0].loginDate);
          if(data[1].WebSupCopyRight && data[1].WebSupCopyRight!="")
          {
            this.webSupCopyRight = data[1].WebSupCopyRight;
          }
          if(data[1].InternetContentProvider && data[1].InternetContentProvider!="")
          {
            this.internetContentProvider = data[1].InternetContentProvider;
          }
          if(data[1].InternetContentProviderHref && data[1].InternetContentProviderHref!="")
          {
            this.internetContentProviderHref = data[1].InternetContentProviderHref;
          }
          loadAndUpdateVersion(this);
          if(data[1].IsA10){
            sessionStorage.setItem("VersionType","A10");
          }
        })
    },
    linkHref(){
      if(this.internetContentProviderHref && this.internetContentProviderHref !=""){
        window.open(this.internetContentProviderHref);
      }
    },
    //跳转发货�?
    turnToCar() {
      this.$router.push("/Home/DeliverCar");
    },

    //修改密码操作;修改单据操作；查看登录信�?
    handleCommand(command) {
      if (command == "changePwd") {
        this.$refs.dialog.dialogFormVisible = true
      }
      if(command == "loginInfo"){
        this.userinfodialog = true;
        this.dialoading = true;
        this.axiosInvoke("/AgencyComm/handler/VueSysHandler.ashx?",
        { action: 'getuserdetailinfo' },
        (res) => {
          var data = res.data;
          this.userinfo = data;
          switch(data.MemberType){
            case '0':
              data.MemberType = this.$t('Home.commonuser');
              break; 
            case '1':
              data.MemberType = this.$t('Home.tempuser');
              break; 
            case '2':
              data.MemberType = this.$t('Home.client');
              break; 
            case '3':
              data.MemberType = this.$t('Home.supplier');
              break; 
            default:
              data.MemberType = this.$t('Home.unknow');
              break; 
          }
          this.dialoading = false;
        })
      }
      if(command == "billSetting"){
        this.billSettingdialog = true;
        this.axiosInvoke("/EIP/Functions/BillSetting.ashx",{
          action:'getBillSetting',
          preConfig: false
        },(res)=>{
          var data = res.data;
          console.log(data);
          if(data.fieldRawTextType){
            this.fieldRawTextType = data.fieldRawTextType;
          }else{
            this.fieldRawTextType = "0";
          }
          if(data.toolbarShowStyle){
            this.toolbarShowStyle = data.toolbarShowStyle;
          }else{
            this.toolbarShowStyle = "showIconAndText"
          }
			    var key = this.userId + "_toolbarshowstyle";
			    var value = JSON.stringify({ toolbarShowStyle: this.toolbarShowStyle });
			    localStorage.setItem(key, value);
        })
      }
      if(command == "userInfo"){
        this.userInfoDialog = true;
        this.getCustomerInfo();
      }
    },
    //获取操作菜单
    getOperationMenu() {
      this.axiosInvoke('/AgencyComm/Handler/VueSysHandler.ashx', {
        action: "getoperationmenu",
      }, async (res) => {
        var data = eval(res.data);
        this.operationMenu = data;
      })
    },

    //剪切名称中的Detail 用于左侧导航栏高光定�?
    handlerDetail(path) {
      if (path.indexOf("Detail") > -1 && path.substring(path.indexOf("Detail")+6)=="") {
        path = path.slice(0, path.indexOf("Detail"));
      }
      return path
    },
    handleClose(){
      this.userinfodialog = false;
    },
    BillhandleClose(){
      this.billSettingdialog = false;
    },
    //检查配置包
    CheckDeployPackage(){
      // this.axiosInvoke('/SupplierComm/Handler/VueSysHandler.ashx', {
      //   action: "supcheckdeploypackage",
      // }, async (res) => {
      //   var data = res.data;
      //   this.SCM78 = data.SCM78;
      //   this.QM01 = data.QM01;
      // })
    },
    confirmBillSetting(){
      this.axiosInvoke("/EIP/Functions/BillSetting.ashx",{
        action:'savebillsetting',
        fieldRawTextType:this.fieldRawTextType,
        toolbarShowStyle:this.toolbarShowStyle,
      },(res)=>{
        var data = res.data;
        if(data.success){
          this.billSettingdialog = false;
          this.$store.commit("TIPPOP",{popType:'success',popMessage:this.$t('Home.billsettingsucess')});
          var key = this.userId + "_toolbarshowstyle";
          var value = JSON.stringify({ toolbarShowStyle: this.toolbarShowStyle });
          localStorage.setItem(key, value);
        }
        })
        
    },
    editUserInfo(field){
    },
    getCustomerInfo(){
      this.userInfoLoading = true;
      this.axiosInvoke(this.sysHandlerUrl,{
        action:'getCustomerInfo',
      },(res)=>{
        this.userInfoLoading = false;
        const data = res.data;
        let CustomerDataTable = data.CustomerDataTable;
        this.CountryDataTable = data.CountryDataTable;
        this.ProvinceDataTable = data.ProvinceDataTable;
        this.CityDataTable = data.CityDataTable;
        console.log(CustomerDataTable);
        this.BizPartnerName = CustomerDataTable[0].BizPartnerName;
        this.email = CustomerDataTable[0].EMail;
        this.CityId = CustomerDataTable[0].CityId;
        this.CountryId = CustomerDataTable[0].CountryId;
        this.ProvinceId = CustomerDataTable[0].ProvinceId;
        this.ContactAddress = CustomerDataTable[0].ContactAddress;
        this.Postalcode = CustomerDataTable[0].Postalcode;
        this.OriginUserInfo = CustomerDataTable[0];
        this.language = data.lang;
      })
    },
    SubmitUserInfo(){
      this.dialoading = true;
      this.axiosInvoke(this.sysHandlerUrl,{
        action:'submituserInfo',
        CountryId:this.CountryId,
        ProvinceId:this.ProvinceId,
        CityId:this.CityId,
        ContactAddress:this.ContactAddress,
        EMail:this.email,
        Postalcode:this.Postalcode
      },(res,err)=>{
        this.dialoading = false;
        this.AddressEdit = false;
        this.emailEdit = false;
        if(err){
          this.email = this.OriginUserInfo.EMail;
          this.CityId = this.OriginUserInfo.CityId;
          this.CountryId = this.OriginUserInfo.CountryId;
          this.ProvinceId = this.OriginUserInfo.ProvinceId;
          this.ContactAddress = this.OriginUserInfo.ContactAddress;
          this.Postalcode = this.OriginUserInfo.Postalcode
          this.$store.commit("TIPPOP",{popType:'error',popMessage:this.$t("comm.saveSuc")});
        }else{
          this.$store.commit("TIPPOP",{popType:'success',popMessage:this.$t("comm.saveSuc")});
        }
      })
    },
    userInfoClose(){
      this.emailEdit = false;
      this.AddressEdit = false;
      this.userInfoDialog = false;
    }
  },
  computed: {
    ...mapState(["deliverCarCount", "keepalive"]),
    address(){
      let CountryRow = this.CountryDataTable.filter((v)=>{
        return v.CountryId == this.CountryId;
      })
      let ProvinceRow = this.ProvinceDataTable.filter((v)=>{
        return v.ProvinceId == this.ProvinceId;
      })
      let CityRow = this.CityDataTable.filter((v)=>{
        return v.CityId == this.CityId;
      })
      let CountryName = CountryRow.length>0?CountryRow[0].CountryName:'';
      let ProvinceName = ProvinceRow.length>0?ProvinceRow[0].ProvinceName:'';
      let CityName = CityRow.length>0?CityRow[0].CityName:'';
      if(this.language == "en"){
        return this.ContactAddress + CityName + ProvinceName + this.Postalcode + CountryName ;
      }else{
        return CountryName + ProvinceName + CityName + this.ContactAddress;
      }
    },
    filProvDt(){
      let table = this.ProvinceDataTable.filter((v)=>{
        if(this.CountryId&&this.CountryId!=""){
          return v.BelongToCountry == this.CountryId;
        }
      });
      return table;
    },
    filCityDt(){
      let table = this.CityDataTable.filter((v)=>{
        if(this.CountryId&&this.CountryId!=""){
          return v.BelongToCountry == this.CountryId && v.BelongToProvince == this.ProvinceId;
        }
      });
      return table;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-container {
  height: 100vh;
  position: relative;
}

.el-container /deep/ .el-aside {
  background-color: white;
  max-width: 208px;
  width: 15vw;
  min-width: 178px;
  box-shadow: 7px 0px 6px 0px rgb(0 0 0 / 10%);
  scrollbar-width: none;
}
.logininfo-row{
  margin-bottom: 7px;
  display: flex;
}
.row-detail{
  padding-left:3%; 
}
.row-dot{
  height:5px;
  width: 5px;
  background-color: #249dfa;
  border-radius: 50%;
  margin:auto 2%;
}
.linkHref {
  color: #959595;
  font-size: 14px;
  cursor: pointer;
}
.button {
  /* 灰度100%，图像完全变灰；亮度0%，图像将完全变黑�?00%恢复原始图像�?*/
  filter: grayscale(1) brightness(0.6); 
  cursor: pointer;
  color: #575757;
  font-size: 15px;
}
.button:hover {
  /* 灰度0%，代表元素图�?*/
  filter: grayscale(0);
  cursor: pointer;
  color: #409EFF;
}

@media screen and (max-width: 1180px) {
  .el-container /deep/ .el-main {
  margin: 0px 0px 0px!important;
}
}

.el-container /deep/ .el-aside::-webkit-scrollbar {
  width: 0 !important;
}

.el-container /deep/ .logo {
  text-align: center;
  height: 70px;
  line-height: 80px;
}

.el-container /deep/ .logo img {
  width: 137px;
  height: auto;
}

.el-container /deep/ .el-menu {
  background-color: white;
  width: 100%;
}

.el-container /deep/ .el-menu .svg-icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: text-top;
  margin: 0 0.7rem;
  fill-rule: evenodd;
}

.el-container /deep/ .el-menu-item-group__title,
.el-container /deep/ .el-submenu__title,
.el-container /deep/ .el-submenu .el-menu-item,
.el-container /deep/ .el-menu-item {
  color: #3a8ee6;
  filter: grayscale(1) brightness(0.7);
}

.el-container /deep/ .el-menu-item:focus,
.el-container /deep/ .el-menu-item:hover,
.el-container /deep/ .el-submenu__title:focus,
.el-container /deep/ .el-submenu__title:hover,
.el-container /deep/ .el-menu-item.is-active,
.el-container /deep/ .el-submenu__title.is-active {
  outline: 0;
  background-color: rgba(0, 153, 255,0.15) !important;
  border-right: 4px solid #3a8ee6;
  color:#3a8ee6;
  filter: grayscale(0) brightness(1);
}
.el-submenu /deep/.el-submenu__title:hover i {
  color:#3a8ee6;
}
.el-container /deep/ .el-aside .el-submenu__title,
.el-container /deep/ .el-aside .el-menu-item {
  transition: border-color 0s, background-color .3s, color .3s;
  padding-left: 0 !important;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
}

.el-container /deep/ .el-aside .el-submenu .el-menu-item {
  padding-left: 25% !important;
}

.el-container /deep/ .el-header {
  color: #575757;
  line-height: 55px;
  height: 55px !important;
  display: flex;
  justify-content: flex-end;
  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 10%);
  font-size: 14px;
  background-color: white;
}

.el-container /deep/ .el-header .headinfo {
  display: flex;
  width: 50%;
  justify-content: space-around;
}

.el-container /deep/ .el-header .svg-icon {
  width: 2rem;
  height: 2rem;
  vertical-align: middle;
  margin-right: 0.5rem;
}

.el-container /deep/ .el-header .user span {
  /* display: inline-flex; */
  /* max-height: 100%; */
  min-width: 100px;
  max-width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-inline-box;
  max-height: 63%;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:inherit;
}

.el-container /deep/ .el-header .user i {
  margin-left: 5px;
}

.el-container /deep/ .el-header .user i:hover {
  cursor: pointer;
}

.el-container /deep/ .el-header .deliver:hover {
  cursor: pointer;
}

.el-container /deep/ .el-header .deliver .red {
  color: red;
}

.el-container /deep/ .el-header .exit {
  display: flex;
  cursor: pointer;
}

.el-container /deep/ .el-header .exit .el-button {
  color: black;
  font-size: 14px;
}

.el-container /deep/ .el-main {
  padding: 0;
  margin: 15px 15px 25px 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background-color: white;
  position: relative;
  scrollbar-width: none;
}

.el-container /deep/ .el-main.isDefault {
  margin: 0;
}

.el-container /deep/ .el-main::-webkit-scrollbar {
  width: 0 !important;
}
.el-submenu /deep/.el-submenu__title i{
  color: black;
}
.el-container /deep/ .footer {
  position: absolute;
  bottom: 3px;
  left: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(-50%, 0);
  color: #959595;
  font-size: 14px;
}

.dialogForm /deep/ .el-form-item {
  width: 90%;
  margin-bottom: 30px;
}
.billsetting-row{
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding-bottom: 15px;
}
.billsetting-title{
  width: 30%
}
.billsetting-options{
  width: 70%;
  flex-wrap: wrap;
  display: flex;
}
.billsetting-options .el-radio{
  width: 100%;
  padding-bottom: 10px;
}
.dialogForm /deep/ .el-form-item .el-form-item__content {
  width: calc(100% - 140px);
}
.headAdInfo{
  display: flex;
  width: calc( 50% - 10px );
  justify-content: space-around;
  padding:  0 5px;
}
.headAdInfo span{
  white-space: nowrap;
  padding:  0 5px;
}
.AdMessage{
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.useinfo-contain{
  display: flex;
  flex-wrap: wrap;
}
.useinfo-contain>div{
  width: 100%;
  padding: 10px 15%;
  display: flex;
}
.changeIcon{
    opacity: 0;
    margin: auto 2px;
    width: 3%;
    flex-shrink: 0;
}
.useinfo-contain>div>div:hover .changeIcon,.useinfo-contain>div:hover .userinfo-content{
  opacity: 1;
  color:#409EFF;
  cursor: pointer;
}
.userinfo-content{
  margin: auto 0;
  width: calc(100% - 17px);
}
.userinfo-label{
  white-space: nowrap;
  padding: 5px;
}
.useinfo-contain .el-input{
  width: 75%;
  margin-bottom: 10px;
}
.userinfo-info{
  display: flex;
  width: 90%;
  flex-wrap: wrap;
  padding: 0px 10px;
}
.userinfo-info .addr-label{
  width: 25%;
  margin: auto 0;
  padding-bottom: 10px;
}
.userinfo-info .el-select{
  width: 75%;
  margin-bottom: 10px;
}
.userinfo-info .userinfo-btns{
  display: flex;justify-content: center;width: 80%;
}
.el-dialog{
  min-width: 200px;
}
</style>
